module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "ibox float-e-margins"
  }, [_c('div', {
    staticClass: "ibox-title"
  }, [_c('div', {
    staticClass: "ibox-tools"
  }, [_c('router-link', {
    staticClass: "btn btn-link",
    attrs: {
      "to": {
        name: 'Dashboard-Condo-Name-Create'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Project Name")])], 1)]), _c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "row"
  }, [_vm._m(0)]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('div', {
    staticClass: "project_table"
  }, [_vm._m(1), _vm._l((_vm.projectsName), function(name) {
    return _c('div', {
      staticClass: "table_body"
    }, [_c('div', {
      staticClass: "td-name"
    }, [_vm._v(_vm._s(name.title ? name.title : '-'))]), _c('div', {
      staticClass: "td-location"
    }, [_vm._v(_vm._s(name.location ? name.location : '-'))]), _c('div', {
      staticClass: "td-create"
    }, [_vm._v(_vm._s(name.create_by ? name.create_by : '-') + " "), _c('small', [_vm._v(_vm._s(name.create_date ? _vm.formatDate(name.create_date) : '-'))])]), _c('div', {
      staticClass: "td-update"
    }, [_vm._v(_vm._s(name.update_by ? name.update_by : '-') + " "), _c('small', [_vm._v(_vm._s(name.update_date ? _vm.formatDate(name.update_date) : '-'))])]), _c('div', {
      staticClass: "td-action text-right"
    }, [_c('router-link', {
      staticClass: "btn btn-default btn-xs",
      attrs: {
        "to": {
          name: 'Dashboard-Condo-Name-Edit',
          params: {
            id: name.id
          }
        }
      }
    }, [_vm._v("Edit")]), _vm._v("   "), _c('button', {
      staticClass: "btn btn-xs",
      class: name.del_flag == '0' ? 'btn-warning' : 'btn-primary',
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.onDelete({
            id: name.id,
            flag: name.del_flag
          })
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (name.del_flag == '0'),
        expression: "name.del_flag == '0'"
      }]
    }, [_vm._v("Delete")]), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (name.del_flag == '1'),
        expression: "name.del_flag == '1'"
      }]
    }, [_vm._v("Restore")])])], 1)])
  })], 2)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', [_vm._v("Loading...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table_head"
  }, [_c('div', {
    staticClass: "td-name"
  }, [_vm._v("PROJECT NAME")]), _c('div', {
    staticClass: "td-location"
  }, [_vm._v("LOCATION")]), _c('div', {
    staticClass: "td-create"
  }, [_vm._v("CREATE")]), _c('div', {
    staticClass: "td-update"
  }, [_vm._v("UPDATE")]), _c('div', {
    staticClass: "td-action"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b4060bd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/condo/name/index.vue
// module id = 421
// module chunks = 3